var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCandLeafLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_78)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_722_78",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 34
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.2926,
    cy: 16.9761,
    r: 16.8067,
    fill: "#F578A5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_722_78)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.2926,
    cy: 16.9761,
    r: 16.8067,
    fill: "#56B280"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.56204 33.5395V33.9072H9.92969H25.5185H25.8862V33.5395V26.9985C25.8862 26.3977 25.41 25.905 24.8095 25.8845L10.7146 25.404C10.0845 25.3825 9.56204 25.8875 9.56204 26.518V33.5395Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.735294
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_722_78)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8 11.9708C16.2251 7.20856 14.7518 3.33223 14.7559 3.32763C14.6833 3.13351 14.7818 2.91731 14.976 2.84469C15.0739 2.80806 15.1826 2.81396 15.276 2.86093C21.4577 5.81893 24.1178 9.63743 24.6273 13.0898C24.8298 14.4311 24.7032 15.8015 24.2584 17.0831C23.8508 18.2656 23.1719 19.3362 22.2761 20.2091C20.553 21.8732 18.1449 22.6403 15.7682 21.8626C15.1602 21.6643 14.5865 21.3733 14.0674 20.9999C13.026 20.2524 12.236 19.2064 11.802 18.0002C11.3416 16.7101 11.3269 15.3029 11.7605 14.0035C11.9999 13.2763 12.3506 12.5906 12.8 11.9708Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8312 3.45089C14.6807 3.30848 14.674 3.07096 14.8164 2.92043C14.9588 2.76989 15.1964 2.76324 15.3469 2.90565C15.358 2.91613 15.3684 2.92727 15.3781 2.93902C15.3919 2.95144 18.3765 6.07991 18.8028 12.1266L18.8073 12.1833C18.8993 13.5965 18.8539 15.0154 18.6716 16.4198L20.7124 14.8559C20.8834 14.7387 21.1169 14.7822 21.2341 14.9531C21.3402 15.1079 21.3157 15.3172 21.1768 15.4432L18.5097 17.481C17.9126 20.9913 15.8077 25.9574 18.5942 29.0656C18.7284 29.2235 18.7091 29.4604 18.5512 29.5946C18.4009 29.7223 18.1773 29.7118 18.0396 29.5706C14.6982 25.8462 17.1296 21.2324 17.795 17.2425L17.8037 17.1865C18.0743 15.5988 18.167 13.9858 18.0802 12.3776L15.6814 10.62C15.5103 10.503 15.4664 10.2695 15.5833 10.0984C15.7003 9.92729 15.9338 9.88341 16.1049 10.0004C16.112 10.0052 16.1189 10.0103 16.1256 10.0156L17.9843 11.384C17.4045 6.14249 14.8421 3.46346 14.8312 3.45089Z",
    fill: "#56B280"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_78"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.6134,
    height: 33.6134,
    fill: "white",
    transform: "translate(0.48584 0.169434)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_722_78"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.6274,
    height: 20.6274,
    fill: "white",
    transform: "translate(2.46729 16.6353) rotate(-48)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandLeafLogo);
export default __webpack_public_path__ + "static/media/CandLeafLogo.e182584309dd6da804569a5f01112935.svg";
export { ForwardRef as ReactComponent };